module.exports = __webpack_public_path__ + "img/pip-in.1c94489e.svg";